import React, { createContext, useState, useEffect } from "react";
import { getProfile, login as apiLogin, logout as apiLogout } from "../api/auth";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem("token") || null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProfile = async () => {
            if (!token) {
                setLoading(false);
                return;
            }
            try {
                const profile = await getProfile();
                setUser(profile);
            } catch (err) {
                console.error("Profile fetch failed:", err);
                setToken(null);
                localStorage.removeItem("token");
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, [token]);

    const login = async (email, password) => {
        const data = await apiLogin(email, password);
        localStorage.setItem("token", data.token);
        setToken(data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await apiLogout();
        } catch (err) {
            console.error("Logout failed:", err);
        } finally {
            localStorage.removeItem("token");
            setToken(null);
            setUser(null);
        }
    };

    return (
        <AuthContext.Provider value={{ user, token, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
